import HomeDtBannerV1 from '../../../images/vanish/qr-codes/home_dt_banner_v1.svg'
import HomeDtBannerV2 from '../../../images/vanish/qr-codes/home_dt_banner_v2.svg'
import HomeDtBannerV3 from '../../../images/vanish/qr-codes/home_dt_banner_v3.svg'
import HomeDtSearchV1 from '../../../images/vanish/qr-codes/home_dt_search_v1.svg'
import HomeDtSearchV2 from '../../../images/vanish/qr-codes/home_dt_search_v2.svg'
import HomeDtSearchV3 from '../../../images/vanish/qr-codes/home_dt_search_v3.svg'
import HomeMbBannerV1 from '../../../images/vanish/qr-codes/home_mb_banner_v1.svg'
import HomeMbBannerV2 from '../../../images/vanish/qr-codes/home_mb_banner_v2.svg'
import HomeMbBannerV3 from '../../../images/vanish/qr-codes/home_mb_banner_v3.svg'
import HomeMbSearchV1 from '../../../images/vanish/qr-codes/home_mb_search_v1.svg'
import HomeMbSearchV2 from '../../../images/vanish/qr-codes/home_mb_search_v2.svg'
import HomeMbSearchV3 from '../../../images/vanish/qr-codes/home_mb_search_v3.svg'
import SerpDtRbottomV1 from '../../../images/vanish/qr-codes/serp_dt_rbottom_v1.svg'
import SerpDtRbottomV2 from '../../../images/vanish/qr-codes/serp_dt_rbottom_v2.svg'
import SerpDtRbottomV3 from '../../../images/vanish/qr-codes/serp_dt_rbottom_v3.svg'
import SerpDtRtopV1 from '../../../images/vanish/qr-codes/serp_dt_rtop_v1.svg'
import SerpDtRtopV2 from '../../../images/vanish/qr-codes/serp_dt_rtop_v2.svg'
import SerpDtRtopV3 from '../../../images/vanish/qr-codes/serp_dt_rtop_v3.svg'
import SerpMbMtopV1 from '../../../images/vanish/qr-codes/serp_mb_mtop_v1.svg'
import SerpMbMtopV2 from '../../../images/vanish/qr-codes/serp_mb_mtop_v2.svg'
import SerpMbMtopV3 from '../../../images/vanish/qr-codes/serp_mb_mtop_v3.svg'
import Default from '../../../images/vanish/qr-codes/default.svg'

const qrCodeMapping = {
    default: {
        qrCode: Default,
        link: 'https://vanish.go.link?adj_t=1viwfglq',
    },
    home_dt_banner_v1: {
        qrCode: HomeDtBannerV1,
        link: 'https://vanish.go.link?adj_t=1vcorib0',
    },
    home_dt_banner_v2: {
        qrCode: HomeDtBannerV2,
        link: 'https://vanish.go.link?adj_t=1vd6197l',
    },
    home_dt_banner_v3: {
        qrCode: HomeDtBannerV3,
        link: 'https://vanish.go.link?adj_t=1v2vxhfl',
    },
    home_dt_search_v1: {
        qrCode: HomeDtSearchV1,
        link: 'https://vanish.go.link?adj_t=1vzon8up',
    },
    home_dt_search_v2: {
        qrCode: HomeDtSearchV2,
        link: 'https://vanish.go.link?adj_t=1vf1wta6',
    },
    home_dt_search_v3: {
        qrCode: HomeDtSearchV3,
        link: 'https://vanish.go.link?adj_t=1vcrtoeu',
    },
    home_mb_banner_v1: {
        qrCode: HomeMbBannerV1,
        link: 'https://vanish.go.link?adj_t=1v15giwq',
    },
    home_mb_banner_v2: {
        qrCode: HomeMbBannerV2,
        link: 'https://vanish.go.link?adj_t=1v5224i8',
    },
    home_mb_banner_v3: {
        qrCode: HomeMbBannerV3,
        link: 'https://vanish.go.link?adj_t=1vjihvsx',
    },
    home_mb_search_v1: {
        qrCode: HomeMbSearchV1,
        link: 'https://vanish.go.link?adj_t=1vae5g5m',
    },
    home_mb_search_v2: {
        qrCode: HomeMbSearchV2,
        link: 'https://vanish.go.link?adj_t=1vlmdyjy',
    },
    home_mb_search_v3: {
        qrCode: HomeMbSearchV3,
        link: 'https://vanish.go.link?adj_t=1v4bx2wy',
    },
    serp_dt_rbottom_v1: {
        qrCode: SerpDtRbottomV1,
        link: 'https://vanish.go.link?adj_t=1v7hcfs5',
    },
    serp_dt_rbottom_v2: {
        qrCode: SerpDtRbottomV2,
        link: 'https://vanish.go.link?adj_t=1vzw6920',
    },
    serp_dt_rbottom_v3: {
        qrCode: SerpDtRbottomV3,
        link: 'https://vanish.go.link?adj_t=1vjtemrg',
    },
    serp_dt_rtop_v1: {
        qrCode: SerpDtRtopV1,
        link: 'https://vanish.go.link?adj_t=1vno9kkn',
    },
    serp_dt_rtop_v2: {
        qrCode: SerpDtRtopV2,
        link: 'https://vanish.go.link?adj_t=1vgn5z7b',
    },
    serp_dt_rtop_v3: {
        qrCode: SerpDtRtopV3,
        link: 'https://vanish.go.link?adj_t=1vi12ysu',
    },
    serp_mb_mtop_v1: {
        qrCode: SerpMbMtopV1,
        link: 'https://vanish.go.link?adj_t=1v1b3lmp',
    },
    serp_mb_mtop_v2: {
        qrCode: SerpMbMtopV2,
        link: 'https://vanish.go.link?adj_t=1vlqeem0',
    },
    serp_mb_mtop_v3: {
        qrCode: SerpMbMtopV3,
        link: 'https://vanish.go.link?adj_t=1v8nd4ti',
    },
}

export const getLinkData = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const source = urlParams.get('source') || 'default'
    const linkData = qrCodeMapping[source] || qrCodeMapping.default
    return {
        ...linkData,
        source,
    }
}
